import React, { Component } from 'react';
//import { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import './style.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import PlayerVideo from '../../components/VideoPlayer/VideoPlayer';
import PlayerVideo from 'components/VideoPlayer/VideoPlayerV2';
// eslint-disable-next-line no-unused-vars
import LinkTo from 'components/LinkTo/LinkTo';
//import { user_Status } from 'Api/Api';
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import Avatar from 'Assets/avatarnew.svg';
import Button from 'components/Button/Button';
import { local_routes } from 'utils/Routes';
import ContactReportModal from 'components/ContactReportModal/ContactReportModal';
import Modal from "react-bootstrap/Modal";
import { apiUrl, user_entity_uuid, user_Status, myHeaders_With_Cache_Control, myHeaders_Auth_With_Cache_Control } from "Api/Api";
import axios from 'axios';

class CommunityPKPlayer extends Component {
  constructor (props) {
    super(props);
    this.state = {
      loading: true,
      showingModal: false,
      workspace_base_url: this.props.workspace_base_url,
      current_presentation_index: 0,
      presentation_array: this.props.presentation_array,
      event_info: this.props.event_info,
      likeLabel: 'like',
      likeLoader: false,
      user_applauded_presentations: {}
    };
    
    /*
    this.state.presentation_array.forEach(item => {
      if (item.presenter_info && item.presenter_info.avatar_image_url) {
        let url = item.presenter_info.avatar_image_url;
        let array = url.split("/");
        item.presenter_info.avatar_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_125x125/${array[5]}`;
      }
    });
    */
    console.log("CommunityPKPlayer constructor");
  }
  
  presentationIndexChange = async (new_presentation_index,user_applauded_presentations) => {
    console.log("CommunityPKPlayer presentationIndexChange",new_presentation_index);
    // get presenter info for presentation if we don't have it already
    let new_state = {...this.state};
    if (user_applauded_presentations) {
      new_state.user_applauded_presentations = user_applauded_presentations;
    }
    
    if (new_presentation_index >= new_state.presentation_array.length) {
      new_presentation_index = 0;
    }
    
    new_state.current_presentation_index = new_presentation_index;
    let presentation_info = new_state.presentation_array[new_presentation_index];
    if (!presentation_info.presenter_info) {
      let presenter_response = await axios.get(`${apiUrl}presentations/${presentation_info.entity_uuid}/users?filter_obj=${encodeURIComponent('{"presenter_integer":{"gte":1}}')}`, myHeaders_Auth_With_Cache_Control);
      if (presenter_response.data.length > 0) {
        presentation_info.presenter_info = presenter_response.data[0];
        // add full_name
        if (presentation_info.presenter_info.firstname && presentation_info.presenter_info.lastname) {
            presentation_info.presenter_info.full_name = presentation_info.presenter_info.firstname+' '+presentation_info.presenter_info.lastname;
        } else if (presentation_info.presenter_info.lastname) {
            presentation_info.presenter_info.full_name = presentation_info.presenter_info.lastname;
        } else if (presentation_info.presenter_info.firstname) {
            presentation_info.presenter_info.full_name = presentation_info.presenter_info.firstname;
        } else {
            presentation_info.presenter_info.full_name = 'Unknown';
        }
        
        if (presentation_info.presenter_info.avatar_image_url) {
          // avatar_image_url -> circle125x125
          let url = presentation_info.presenter_info.avatar_image_url;
          let array = url.split("/");
          presentation_info.presenter_info.avatar_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_125x125/${array[5]}`;
        }
        if (presentation_info.image_url) {
          // avatar_image_url -> circle125x125
          let url = presentation_info.image_url;
          let pad_color = "black";
          if (presentation_info.pad_color) {
            pad_color = presentation_info.pad_color;
          }
          let array = url.split("/");
          presentation_info.image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/pad${pad_color}_1280x720/${array[5]}`;
        }
        
        
      }
    }
    if (new_state.user_applauded_presentations[presentation_info.entity_uuid]) {
      new_state.likeLabel = "unlike";
    } else {
      new_state.likeLabel = "like";
    }
    new_state.loading = false;
    
    console.log("CommunityPKPlayer presentationIndexChange", new_state);
    this.setState( new_state );
  }
  
  async componentDidMount () {
    console.log("CommunityPKPlayer componentDidMount");
    
    let user_applauded_presentations = {};
    if (user_Status === 1) {
      // get all likes for the user
      
      let user_like_response = await axios.get(`${apiUrl}users/${user_entity_uuid}/presentations.audience?filter_obj=${encodeURIComponent('{"applauded_time":{"gte":1}}')}&attributes_array=${encodeURIComponent('["entity_uuid"]')}`);
      for (let presentation_info of user_like_response.data) {
        user_applauded_presentations[presentation_info.entity_uuid] = true;
      }
      //this.setState({
      //  user_applauded_presentations
      //});
    }
    
    await this.presentationIndexChange(0,user_applauded_presentations);
  }

  // Toogles modal show
  showModal = () => {
    this.setState({ showingModal: true });
  }
  // Toogles modal hide
  hideModal = () => {
    this.setState({ showingModal: false });
  }
  
  handleLikeClick = async () => {
    console.log("handleLikeClick");
    if (user_Status === 1) {
      let new_state = {...this.state}
      let presentation_info = new_state.presentation_array[this.state.current_presentation_index];
      // Applaud Count API starts
      this.setState({likeLoader:true});
      let decrement_flag = "";
      let new_label = 'unlike';
      if (this.state.likeLabel === 'unlike') {
          decrement_flag = "&decrement=true";
          new_label = 'like';
          new_state.user_applauded_presentations[presentation_info.entity_uuid] = false;
      } else {
          new_state.user_applauded_presentations[presentation_info.entity_uuid] = true;
      }
      let increment_response = await axios.post(`${apiUrl}presentations/${presentation_info.entity_uuid}/incrementCount?count_type=applaud${decrement_flag}`, {});

      if (increment_response.data.message === "count not incremented - user has already done this action") {
          this.setState({ likeLoader: false });
          return null;
      }
      
      presentation_info.applaud_count = increment_response.data.new_count;
      
      new_state.likeLabel = new_label;
      new_state.likeLoader = false;
      
      this.setState( new_state );

      // now bust cache
      await Promise.all([
          axios.get(`${apiUrl}presentations/${presentation_info.friendly_url}`, myHeaders_With_Cache_Control),
          axios.get(`${apiUrl}events/${this.state.event_info.entity_uuid}/presentations?sort_obj=${encodeURIComponent('{"order_integer":"asc"}')}&filter_obj=${encodeURIComponent('{"order_integer":{"gte":1}}')}`, myHeaders_With_Cache_Control),
          axios.get(`${apiUrl}users/${user_entity_uuid}/presentations.audience?filter_obj=${encodeURIComponent('{"applauded_time":{"gte":1}}')}&attributes_array=${encodeURIComponent('["entity_uuid"]')}`, myHeaders_Auth_With_Cache_Control)
      ]);

      // Applaud Count API ends
    }
  }

  onVideoPlayComplete = async (isComplete) => {
    //console.log("onVideoPlayComplete",isComplete);
    if (isComplete) {
      console.log("onVideoPlayComplete",isComplete);
      this.presentationIndexChange(this.state.current_presentation_index+1);
    }
  };

  render () {
    
    let presentation_info = this.state.presentation_array[this.state.current_presentation_index];
    let headline = "Community PK Event: "+this.state.event_info.entity_name+" - PK #"+(this.state.current_presentation_index+1);

    if (this.state.loading === true) {
      return (
        <ActivityIndicator theme="spinner" />
      );
    }
    
    return (
      <React.Fragment>
        <div className="main-section">
          
          <div className="spotlightVideo" style={{ marginTop: "0px", marginBottom: "0px" }}>
            
            <div className="container">
              <div className="videotitle">
                <NavLink to={`${this.state.workspace_base_url}${local_routes.events}/${this.state.event_info.friendly_url}`}>
                  <h2>{headline}</h2>
                </NavLink>
                <br/><br/><br/>
              </div>
              <Row >
                
                <Col sm={12} md={12} lg={8}>
                  <div className="city-video">
                    <PlayerVideo
                      key={presentation_info.entity_uuid}
                      presentation_data={presentation_info}
                      autoPlayStatus={true}
                      onClickVideoPlayComplete={this.onVideoPlayComplete}
                    />
                  </div>
                </Col>
                <Col sm={12} md={12} lg={4}>
                  <div className="city-det">
                    <NavLink to={`${this.state.workspace_base_url}${local_routes.presentations}/${presentation_info.friendly_url}`}>
                      <h3>{presentation_info.entity_name}</h3>
                    </NavLink>
                    <div className="media-options">
                      <div className="left">
                        <Modal size="lg" show={this.state.showingModal} onHide={this.hideModal} className="modal-content-custom" >
                            <div><ContactReportModal modalText = "Please use the 'Support' button in the lower right" /></div>
                            <div>
                                <Button theme="modal-button" OnClickMet={this.hideModal}>
                                    x
                            </Button>
                            </div>
                        </Modal>
                        <a onClick={this.showModal}><i className="fa fa-flag"></i></a>
                      </div>
                      <div className="right">
                        <a className="likeBtn"><i className="fa fa-heart"></i>{presentation_info.applaud_count || 0}</a>
                        {
                          user_Status === 1 ?
                            <React.Fragment>
                              {
                                this.state.likeLoader === true ?
                                  // <ActivityIndicator theme="button-Loader-Minimal" themeSpinner="spinner-border like-btn" />
                                  <ActivityIndicator theme="spinnerbgBlack likeSpinner"/>
                                  :
                                  <React.Fragment>
                                    <a onClick={this.handleLikeClick} className="like-label like-media">
                                      {this.state.likeLabel}
                                    </a>
                                  </React.Fragment>
                              }
                            </React.Fragment>
                            : null
                        }
                      </div>
                    </div>
                    {
                      (presentation_info.presenter_info && presentation_info.presenter_info.full_name) ?
                        
                        presentation_info.presenter_info.friendly_url ?
                          <NavLink to={`${this.state.workspace_base_url}${local_routes.users}/${presentation_info.presenter_info.friendly_url}`}>
                            <div className="media-author">
                              <img alt='author' src={presentation_info.presenter_info.avatar_image_url || Avatar} />
                              <h4>{presentation_info.presenter_info.full_name}</h4>
                              <span>{presentation_info.presenter_info['description'] || ""}</span>
                            </div>
                          </NavLink>
                        :
                          <div className="media-author">
                            <img alt='author' src={presentation_info.presenter_info.avatar_image_url || Avatar} />
                            <h4>{presentation_info.presenter_info.full_name}</h4>
                            <span>{presentation_info.presenter_info['description'] || ""}</span>
                          </div>
                      : null
                    }
  
                    <div dangerouslySetInnerHTML={{ __html: (presentation_info['description'] || "") }} className="videoDescription" />
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default CommunityPKPlayer;